
let defaultState = {
    
    text: ""
}

export default function (state=defaultState, action) {

    switch (action.type) {
        case "KEYBOARD_ADD":
            return Object.assign({}, state, {
                text: state.text + action.symbol
            })
        
        case "KEYBOARD_BACKSPACE":
            return Object.assign({}, state, {
                text: state.text.slice(0,-1)
            })
        
        case "KEYBOARD_CLEAR":
            return Object.assign({}, state, {
                text: "",
            })
        
        default:
            return state
    }

}
    


// WEBPACK FOOTER //
// ./src/reducers/keyboard.js